'use strict';

/**
 *
 * @name: nsStoryTags
 *
 */

import DirectiveTemplate from './story-tags.directive.html';

function NsStoryTagsDirective() {

  'ngInject';

  return {
    restrict: 'EA',
    replace: true,
    scope: {
      tags: '=nsStoryTags'
    },
    template: DirectiveTemplate,
    controller: nsStoryTagsDirectiveController,
    controllerAs: 'storyTags'
  };
}

function nsStoryTagsDirectiveController($rootScope, $scope, $element, $timeout) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /*jshint validthis: true */
  var storyTags = this;

  storyTags.tags = $scope.tags;
  storyTags.scroll = {
    pxPerClick: 80,
    animationTime: 100,
    container: $element.find('ul.meta-tags'),
    currentScroll: 0,
    showGoRight: true,
    showGoLeft: false
  };

  /**
   *
   * @PUBLIC
   *
   */

  storyTags.scroll.goRight = function () {

    var scrollLeft = storyTags.scroll.container[0].scrollLeft + storyTags.scroll.pxPerClick;
    _scrollLeftContainer(scrollLeft);
  };

  storyTags.scroll.goLeft = function () {

    var scrollLeft = storyTags.scroll.container[0].scrollLeft - storyTags.scroll.pxPerClick;
    _scrollLeftContainer(scrollLeft);
  };

  /**
   *
   * @PRIVATE
   *
   */

  function _scrollLeftContainer(value) {

    storyTags.scroll.container
      .animate({
        scrollLeft: value
      }, storyTags.scroll.animationTime);
  }

  function _shouldShowGoLeft() {

    var scrollLeft = storyTags.scroll.container[0].scrollLeft;
    return scrollLeft > 0;
  }

  function _shouldShowGoRight() {

    var scrollLeft = storyTags.scroll.container[0].scrollLeft;
    var scrollWidth = storyTags.scroll.container[0].scrollWidth;
    var clientWidth = storyTags.scroll.container[0].clientWidth;

    return (scrollLeft + clientWidth) < (scrollWidth - 1);
  }

  function _containerOnScroll() {

    $timeout(function () {
      storyTags.scroll.showGoLeft = _shouldShowGoLeft();
      storyTags.scroll.showGoRight = _shouldShowGoRight();
    });
  }

  function _bindScroll() {

    storyTags.scroll.container
      .on('scroll', _containerOnScroll);
  }

  function _unBindScroll() {

    storyTags.scroll.container
      .off('scroll', _containerOnScroll);
  }

  function _onScopeDestroy(_fn) {

    $scope.$on('$destroy', function () {

      if (_fn) {
        _fn();
      }
    });
  }

  /**
   *
   * @INIT
   *
   */

  _bindScroll();
  _onScopeDestroy(function () {
    _unBindScroll();
  });
  $timeout(function () {
    storyTags.scroll.showGoLeft = _shouldShowGoLeft();
    storyTags.scroll.showGoRight = _shouldShowGoRight();
  });
}

export default NsStoryTagsDirective;



// WEBPACK FOOTER //
// ./app/pages/story/story-tags.directive.js